export function convertDurationTimeToMinutes(durationTime) {
  let hours = parseInt(durationTime.split(':')[0])
  let minutes = parseInt(durationTime.split(':')[1])
  return hours * 60 + minutes
}

export function convertMinutesToDurationTime(totalMinutes, editting = true) {
  let hours = Math.floor(totalMinutes / 60)
  let minutes = totalMinutes % 60
  let charSpace = editting ? ':' : "H"
  if (minutes < 10) { minutes = '0' + minutes }
  return `${hours}${charSpace}${minutes}`
}



// WEBPACK FOOTER //
// ./src/helpers/timeCodes.js